module.exports = __webpack_public_path__ + "img/icon_wxzf.72e8cd9b.svg";